var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about wrapper-1080"},[_c('div',{staticClass:"Aligner"},[_c('div',{staticClass:"Aligner-item"},[_c('h2',[_vm._v("Welcome, "+_vm._s(_vm.fullname))]),_c('h3',[_vm._v("to 8.2 IDAT")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }